import type { Topic } from '@/types/movie';

export const topics: Topic[] = [
  {
    id: 'huayu-highscore',
    title: '华语高分剧集精选',
    subtitle: '口碑与热度齐飞，这五部值得熬夜追完',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20cover%20of%20overlapping%20glowing%20tv%20screens%20arranged%20in%20a%20dark%20hall%2C%20deep%20navy%20tones%20with%20warm%20amber%20screen%20light%2C%20minimal%20premium%20streaming%20collection%20aesthetic%2C%20soft%20negative%20space%2C%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=topic-cover-01&orientation=landscape',
    intro: '从历史权谋到都市悬疑，久久热为你精选近两年口碑最硬的华语剧集。它们有的靠缜密的剧本封神，有的凭扎实的表演打动人心，无论你偏爱哪一口，都能在这份清单里找到愿意一口气追完的那一部。',
    groups: [
      {
        name: '权谋与历史',
        reason: '格局宏大、台词考究，适合喜欢厚重叙事的观众。',
        movieIds: ['throne-scheme', 'homeland-past'],
      },
      {
        name: '悬疑与都市',
        reason: '节奏紧凑、反转不断，追起来完全停不下来。',
        movieIds: ['cloud-city', 'urban-pulse', 'dark-alley'],
      },
    ],
  },
  {
    id: 'scifi-universe',
    title: '科幻宇宙之旅',
    subtitle: '从深海到星空，一次关于未知的想象漫游',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20cover%20of%20a%20deep%20space%20nebula%20blending%20into%20dark%20ocean%20water%20with%20tiny%20glowing%20particles%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20minimal%20sci-fi%20collection%20aesthetic%2C%20generous%20negative%20space%2C%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=topic-cover-02&orientation=landscape',
    intro: '科幻最迷人的地方，是它让我们暂时跳出日常，去想象一种完全不同的可能。这个专题汇集了久久热站内最受欢迎的科幻作品，从星际航行到深海惊魂，带你完成一次关于未知的想象漫游。',
    groups: [
      {
        name: '星际与远方',
        reason: '宏大世界观搭配震撼视觉，属于大银幕级别的想象。',
        movieIds: ['star-return', 'dream-traveler'],
      },
      {
        name: '深潜与悬疑',
        reason: '把恐惧藏在黑暗深处，越往下看越让人屏住呼吸。',
        movieIds: ['deep-sea-echo', 'double-life'],
      },
    ],
  },
  {
    id: 'healing-weekend',
    title: '周末治愈清单',
    subtitle: '窝在沙发里，用温柔的故事给自己充充电',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20cover%20of%20a%20cozy%20warm%20living%20room%20glow%20melting%20into%20soft%20abstract%20shapes%2C%20deep%20navy%20shadows%20and%20gentle%20amber%20light%2C%20minimal%20calm%20collection%20aesthetic%2C%20soft%20negative%20space%2C%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=topic-cover-03&orientation=landscape',
    intro: '有些作品不需要烧脑，也不追求刺激，它们只是安安静静地讲一个温暖的故事，让你在忙碌一周之后，重新感到被温柔对待。这份周末治愈清单，献给需要慢下来的你。',
    groups: [
      {
        name: '温暖日常',
        reason: '没有大起大落，只有让人会心一笑的生活细节。',
        movieIds: ['midnight-diner', 'spring-confession', 'music-live'],
      },
      {
        name: '真诚与成长',
        reason: '关于坚持、告别与和解，看完心里会亮一亮。',
        movieIds: ['chasing-wind', 'time-letter', 'farewell-rain'],
      },
    ],
  },
];